module.exports = __webpack_public_path__ + "img/bubble-size.8ea69ab7.svg";